import React from "react";
import { useLang } from "../contexts/LangContext";
import { Button } from "../components/ui/button";
import { X } from "lucide-react";

export default function GeoBanner() {
  const { suggestion, setSuggestion, setLang, flags, names } = useLang();
  if (!suggestion) return null;
  return (
    <div
      data-testid="geo-banner"
      className="bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] text-sm"
    >
      <div className="container-xl py-2 flex items-center justify-between gap-4">
        <span>
          {flags[suggestion.lang]} Sembri connetterti dalla tua area — vuoi continuare in{" "}
          <strong>{names[suggestion.lang]}</strong>?
        </span>
        <div className="flex items-center gap-2">
          <Button
            data-testid="geo-banner-accept"
            size="sm"
            variant="secondary"
            onClick={() => { setLang(suggestion.lang); setSuggestion(null); }}
          >
            Sì, cambia
          </Button>
          <button data-testid="geo-banner-dismiss" onClick={() => setSuggestion(null)} className="p-1 opacity-80 hover:opacity-100">
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
